/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetFboLocationGroupsResponse } from '../../models/get-fbo-location-groups-response';

export interface GetAllFboLocationGroups$Params {

/**
 * the page number.
 */
  page?: number;

/**
 * the size of a page
 */
  size?: number;

/**
 * sort
 */
  sort?: string;

/**
 * Search by location group name.
 */
  search?: string;
}

export function getAllFboLocationGroups(http: HttpClient, rootUrl: string, params?: GetAllFboLocationGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<GetFboLocationGroupsResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllFboLocationGroups.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetFboLocationGroupsResponse>;
    })
  );
}

getAllFboLocationGroups.PATH = '/api/administration/fbo-locations-groups';
